import React, { useContext } from "react";
import { Link } from "react-router-dom";

import {
  Toolbar,
  IconButton,
  AppBar,
  WithStyles,
  withStyles,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import Grid from "@material-ui/core/Grid";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";

import { styles } from "./ToolbarStyles";
import Notificaciones from "../../Notificaciones/Notificaciones";
import { IsMobileContext } from "../../UI/IsMobile/IsMobile";
import VeDiLogoMobile from "../../../assets/images/iconoDrawer.svg";

import { connect, ConnectedProps } from "react-redux";

const mapStateToProps = (state: any) => ({
  usuario: state.usuario.user,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

interface OwnProps {
  handleDrawerToggle: () => void;
  pathname: string;
  logoutHandler: () => void;
}

type Props = PropsFromRedux & WithStyles<typeof styles> & OwnProps;

const displayText = (pathname: string, classes: any, usuario: string) => {
  let text = null;

  switch (pathname) {
    case "/servicios":
      return (
        <>
          <h1 className={classes.titulo}>{`¡Hola! ${
            usuario?.trim().split(" ")[0] || ""
          }`}</h1>
        </>
      );
    case "/novedades-avisos":
      text = "Novedades y Avisos";
      break;
    case "/comunicaciones":
      text = "Comunicaciones";
      break;
    case "/ayuda":
      text = "Ayuda";
      break;
    case "/mi-cuenta":
      text = "Mi cuenta";
      break;
    case "/representaciones":
      text = "Representaciones";
      break;
    case "/representados":
      text = "Representados";
      break;
    case "/administracion":
      text = "Administración";
      break;
    case "/administracion-empleados":
      text = "Administración";
      break;
    case "/administracion-servicios":
      text = "Administración";
      break;
    case "/alta-servicio":
      text = "Alta de Servicio";
      break;
    case "/MisDocumentos":
      text = "Documentos";
      break;
    default:
      text = null;
  }
  if (pathname.startsWith("/vista-servicio/")) {
    text = "Ver Servicio";
  }

  if (pathname.startsWith("/editar-servicio/")) {
    text = "Editar Servicio";
  }
  return text && <h1 className={classes.titulo}>{text}</h1>;
};
const MyToolbar: React.FC<Props> = (props) => {
  const { classes, handleDrawerToggle, pathname, logoutHandler, usuario } =
    props;
  const titulo = displayText(pathname, classes, usuario.nombre);
  const isMobile = useContext(IsMobileContext);

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          className={classes.menuButton}
          color="inherit"
          edge="start"
          onClick={handleDrawerToggle}
          aria-label="Menú"
        >
          <MenuIcon />
        </IconButton>

        <div className={classes.toolbarRightContent}>
          <Grid
            container
            wrap="nowrap"
            justify="space-between"
            alignItems="center"
          >
            <Grid item xs={5}>
              {isMobile ? (
                <Link
                  to="/servicios"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src={VeDiLogoMobile}
                    alt="Logo de VeDi"
                    width="70%"
                    height="70%"
                  />
                </Link>
              ) : (
                titulo
              )}
            </Grid>

            <Grid
              item
              container
              direction="row"
              justify="flex-end"
              alignItems="center"
              xs={7}
            >
              <Grid item>
                <Notificaciones />
              </Grid>
              <Grid item>
                <IconButton
                  className={classes.btnShadowNone}
                  onClick={logoutHandler}
                  aria-label="Cerrar Sesión"
                >
                  <ExitToAppIcon
                    style={{
                      fontSize: 45,
                      cursor: "pointer",
                      color: "#C1C1C1",
                    }}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default withStyles(styles)(
  connector(MyToolbar)
) as React.ComponentType<OwnProps>;
